import cn from 'classnames'
import React from 'react'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'

import * as s from './CollapseIcon.module.scss'

interface ICollapseIconProps {
  open?: boolean
  iconPosition: 'left' | 'right' | 'none'
  onClick?: () => void
}

const CollapseIcon: React.FC<ICollapseIconProps> = ({ open, iconPosition, onClick }) => {
  const wrapperCn = cn(s.icon, s[iconPosition], { [s.isOpen]: open })
  return <Icon className={wrapperCn} name='iconsExpandRight' onClick={onClick} size={KitSize.S} />
}

export default CollapseIcon
